<template>
    <div class="border border-slate-200 py-6 px-4 rounded-2xl space-y-8">
        <h3 class="text-xl font-semibold mb-6">
            {{ $t('Additional options') }}
        </h3>

        <template v-if="addOns.length === 0">
            <p class="text-gray-600">
                {{ $t('There are no additional options available for your cart items.') }}
            </p>
        </template>
        <template v-else>
            <div class="space-y-6 divide-y divide-slate-200">
                <template v-for="addOn in addOns" :key="addOn.id">
                    <div class="pt-6 first:pt-0">
                        <AddOnItem :add-on="addOn" :value="getValue(addOn)" :get-value="getValue" :on-change="(value) => onChange(addOn, value)" />
                    </div>
                </template>
            </div>

            <p class="text-sm text-gray-600">
                {{ $t('Items marked with * are paid at the property.') }}
            </p>
        </template>
    </div>
</template>

<script setup>
import AddOnItem from './AddOnItem.vue'
const props = defineProps({
    addOns: {
        type: Array,
        required: true
    },
    getValue: {
        type: Function,
        required: true
    },
    onChange: {
        type: Function,
        required: true
    }
})
</script>
